import React from 'react'
import {
    Select,
    Form,
    Button
} from 'antd'

import { 
    SendOutlined
} from '@ant-design/icons'

import useEnqueueReport from './useEnqueueReport'

export const pad = (n: any, width: any, z = '0') => {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export default function ReportPosQuadrature() {
    const { enqueue, submitting: loading } = useEnqueueReport('quadrature')
    const [form] = Form.useForm()

    const { Option } = Select

    /**
     * @todo Get from API.
     */
    // const allPeriodosAvailable = [
    //     { value: '10', label: 'Octubre 2022'},
    //     { value: '11', label: 'Noviembre 2022'},
    //     { value: '12', label: 'Diciembre 2022'}
    // ]
    /**
     * @todo Get from API.
     */
    const yearStart = 2022
    const yearEnd = new Date().getFullYear()
    const years = []
    for (let i = yearStart; i <= yearEnd; i++) {
        years.push(i)
    }
    const allPeriodosAvailable = [
        // Años completos
        // ...years.map(y => ({ value: `${y}`, label: `Año Comercial ${y}` })),
        ...years.reduce<any>((acc, y) => {
            const months = [
                { value: `${y}01`, label: `Enero ${y}` },
                { value: `${y}02`, label: `Febrero ${y}` },
                { value: `${y}03`, label: `Marzo ${y}` },
                { value: `${y}04`, label: `Abril ${y}` },
                { value: `${y}05`, label: `Mayo ${y}` },
                { value: `${y}06`, label: `Junio ${y}` },
                { value: `${y}07`, label: `Julio ${y}` },
                { value: `${y}08`, label: `Agosto ${y}` },
                { value: `${y}09`, label: `Septiembre ${y}` },
                { value: `${y}10`, label: `Octubre ${y}` },
                { value: `${y}11`, label: `Noviembre ${y}` },
                { value: `${y}12`, label: `Diciembre ${y}` }
            ]

            for (const month of months) {
                const monthId = months.findIndex((m: any) => m.value === month.value)
                const currentMonth = new Date().getMonth()

                if (monthId && y === new Date().getFullYear() && monthId > currentMonth) {
                    break
                } else {
                    acc.push(month)
                }
            }
            return acc
        }, []),
    ]

    const onFinish = (data: any) => {
        enqueue(data)
    }

    return <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} form={form} onFinish={onFinish} initialValues={{
        mes: `${new Date().getFullYear()}${pad((new Date().getMonth() + 1), 2)}`
        // mes: `${pad(new Date().getMonth() + 1, 2)}`
    }}>
        <p>Puedes solicitar el informe de cuadratura de caja de un periodo determinado.</p>
        <br />
        <Form.Item name="mes" label="Mes">
            <Select
                disabled={loading}
            >
            {allPeriodosAvailable.map(field => (
                <Option value={field.value} key={field.value}>{field.label}</Option>
            ))}
            </Select>
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} icon={<SendOutlined />} className='Accounting--DownloadBtn' >
          Solicitar Informe
        </Button>
    </Form>
}
